<template>
  <div class="rent-container">
    
      <div v-for="(r, index) in result" class="item-content" @click="openDetail(r)">

        <div class="item-img">
          <img :src="r.img"/>
        </div>

        <div class="item-des" style="color:rgba(88, 88, 88, 1);">
          <div style="font-size: 20px;color: black;">{{ r.title }}</div>
          <div class="list">
            <div> 
              <div>{{ r.distance }}</div>
              <div>表显里程</div>
            </div>
            <div> 
              <div>{{ r.time }}</div>
              <div>首次上牌</div>
            </div>
            <div> 
              <div>{{ r.pailiang }}</div>
              <div>排量</div>
            </div>
            <div> 
              <div>{{ r.biansu }}</div>
              <div>变速箱</div>
            </div>
            <div> 
              <div>{{ r.paifang }}</div>
              <div>排放标准</div>
            </div>
            
          </div>
          <div>发布人: {{ r.public }}</div>
          <div>联系方式: {{ r.mobile }}</div>

        </div>

        <div style="color: red;padding: 0 30px 0 10px;">
          <span style="font-size: 25px;">{{ r.xianjia }}</span>

        </div>

        <div style="padding: 0 30px 0 10px;color:rgba(88, 88, 88, 1);">
          新车报价: {{ r.yuanjia }}

        </div>


      </div>
      <ItemDetail :centerDialogVisible="showDetail" :obj="obj" @close="showDetail = false"></ItemDetail>
  </div>
</template>
<script>
import {vech} from '../../data/vichcle'
import ItemDetail from '../../components/ItemDetail.vue'
  export default {
      name: 'Rent',
      components: {
        ItemDetail
      },
      data() {
        return { 
          showDetail: false,
          obj: {},
          rents: vech.data.map((item, index)=> {
            return {
              ...item,
              img: `/img/车辆买卖/${index + 1}.webp`
            }
          }) 
        }
      },
      computed: {
        result() {
          return [...this.rents, ...this.$store.getters.publishItems.filter(i => i.type == '2')]
        }
      },
      methods: {
        openDetail(item) {
          this.obj = item 
          this.showDetail = true
        }
      }
     
  }
</script>

<style scoped>
  
 .item-content {
  margin: 0 100px;
  padding: 5px 0;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ddd;
 }

 .rent-container {
    padding: 20px 10vw;
    background: #ececec;
 }

 .item-img > img{
  width: 200px;
 }

 .item-des {
  flex: 1;
  padding: 0 20px;
  line-height: 2;
 }

 .list {
  display: flex;
  align-items: center;
 }

 .list > div {
  width: 90px;
 }

 .list > div > first-child {
  font-size: 14px;
 }
 .list > div > div:nth-child(2) {
  font-size: 12px;
 }
  
</style>